import { render, staticRenderFns } from "./task-comments.vue?vue&type=template&id=4d3c1dfc&scoped=true&"
import script from "./task-comments.vue?vue&type=script&lang=js&"
export * from "./task-comments.vue?vue&type=script&lang=js&"
import style0 from "./task-comments.vue?vue&type=style&index=0&id=4d3c1dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c1dfc",
  null
  
)

export default component.exports